import {
    ApplyButton,
    MekiHero,
    MekiQuote,
    MekiSectionHeading,
    MekiWorkOverview,
    Paragraphs,
} from 'components/MekiPageSections';

export default function MekiAboutPage() {
    return (
        <main className='w-full bg-white/20'>
            <MekiHero
                title='Ismerd meg Mekis irodánk csapatát!'
                image='/assets/images/meki_content_6.jpg'
                contentId='mi-mekisek-tartalom'
            />

            <section id='mi-mekisek-tartalom' className='relative z-10 -mt-6 scroll-mt-20 bg-stone-50 px-site pb-16 pt-28 sm:pb-24 sm:pt-32'>
                <div className='mx-auto flex w-full max-w-boxed flex-col gap-8 sm:gap-10'>
                    <MekiSectionHeading>A diák az első, a csapatunk a második</MekiSectionHeading>
                    <Paragraphs items={[
                        'Számunkra a Mekis diákmunka szervezése nem csak munka, hanem kihívásokkal teli élmény, amivel a diákoknak segíthetünk életük alakításában. Arra törekszünk, hogy kérdéseitekre és problémáitokra mielőbb megoldásokat találjunk. A Mekis munka pörgőssége pedig az irodánkban is érezhető. Valaki mindig jön-megy, intézkedik, egyeztet, telefonál.',
                    ]} />
                    <figure className='h-[clamp(280px,52vw,680px)] overflow-hidden rounded-3xl bg-neutral-200 shadow-2xl'>
                        <img src='/assets/images/background/mi_mekisek_1.jpg' alt='' className='size-full object-cover' />
                    </figure>

                    <div className='grid grid-cols-1 items-stretch gap-6 lg:grid-cols-2'>
                        <MekiQuote
                            paragraphs={[
                                '„Nagyon sok diákkal kerülünk kapcsolatba, rengeteg pozitív élmény ér. Mindig van egy beszélgetés, egy felvett diák, egy beléptetés, egy megoldott feladat, egy elégedett étteremvezető, egy kiutalt jutalom, ami után az ember sóhajt egy boldogat, hogy nah, ezért is éri meg!”',
                                'Egyszerűen energiával tölt fel minket, ha jó érzéssel és elégedetten távoztok tőlünk.',
                            ]}
                        />
                        <figure className='min-h-80 overflow-hidden rounded-3xl bg-neutral-200 shadow-2xl sm:min-h-96'>
                            <img src='/assets/images/background/mi_mekisek_2.jpg' alt='' className='size-full object-cover' />
                        </figure>
                    </div>

                    <div className='flex flex-col items-center rounded-3xl bg-white p-6 text-center shadow-xl shadow-red-900/5 sm:p-10 lg:p-12'>
                        <Paragraphs items={[
                            'Folyamatosan kihívásokkal nézünk szembe, így a munkánk sosem unalmas, és tudjuk, hogy a csapatunk hozzáállásával, a megoldások keresésével minden elénk vagy a diákjaink elé gördülő akadályt meg tudunk oldani. A Fürge Diák Mekis csapata valójában ugyanolyan baráti társaság, mint egy Meki étterem csapata. Minden nehézségben osztozunk, és minden jó hírnek együtt örülünk. Egy második otthon, ahol örömmel töltjük el az időt, mert tudjuk, hogy jót teszünk, segítünk, és közben jól is érezhetjük magunkat.',
                        ]} className='max-w-5xl' />
                        <p className='mt-7 font-display text-xl font-black text-red-700 sm:text-2xl lg:text-3xl'>
                            Ha te is egy ilyen csapat része lennél a Meki kötelékében, akkor kattints!
                        </p>
                        <ApplyButton className='mt-7' />
                    </div>
                </div>
            </section>

            <MekiWorkOverview />
        </main>
    );
}
